export { default } from './ExternalShareContentRendererLoader';
